import type { LoginButtonKind } from "../../types/homeLanding";

/** URL-uri implicite pentru login. */
export const DEFAULT_LOGIN_URL: Record<LoginButtonKind, string> = {
  business_new:
    "https://jur2.fincompay.com:7002/ifobsClientJur/#/login/sign-in",
  business: "https://jur.fincompay.com:7002/ifobsClientFinCom/Login.action",
  personal: "/personal",
};
